import React from 'react';
import type { HelpHeaderIconButtonProps } from '../../types';
import styles from '../../AppHelpCenter.module.scss';

const HelpHeaderIconButton: React.FC<HelpHeaderIconButtonProps> = ({
  icon,
  label,
  onClick,
  testId,
}) => (
  <button
    type='button'
    aria-label={label}
    data-testid={testId}
    className={styles.iconButton}
    onClick={onClick}
  >
    {icon}
  </button>
);

export default HelpHeaderIconButton;
